import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Spinner from '../../../components/ui/Spinner';
import { clinicalDelegationService, type DelegatedSignature } from '../../../services/clinicalDelegationService';
import { formatSignedAt } from '../../consultations/hooks/delegatedSignature';

/**
 * clinical-record-signing R13: the doctor's views show which records were
 * signed by delegation — the consultations an assistant signed on their
 * behalf, newest first. Empty while delegated signing is off. Doctors only.
 */
const DelegatedSignaturesCard: React.FC = () => {
  const [items, setItems] = useState<DelegatedSignature[] | null>(null);

  useEffect(() => {
    clinicalDelegationService.getDelegatedSignatures()
      .then(setItems)
      .catch(() => setItems([]));
  }, []);

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title d-inline-block">Firmadas por Delegación</h4>
      </div>
      <div className="card-body p-0 table-dash">
        <div className="table-responsive">
          <table className="table mb-0 border-0 custom-table">
            <thead>
              <tr>
                <th>Consulta</th>
                <th>Firmada por</th>
                <th>Fecha</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items === null ? (
                <tr><td colSpan={4} className="text-center py-3"><Spinner /></td></tr>
              ) : items.length === 0 ? (
                <tr><td colSpan={4} className="text-center text-muted py-3">Ninguna consulta firmada por delegación</td></tr>
              ) : (
                items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.consultation_number || `#${item.id}`}</td>
                    <td>{item.signed_by_name || '—'}</td>
                    <td className="text-muted">{formatSignedAt(item.signed_at) ?? '—'}</td>
                    <td>
                      <Link to={`/consultations/${item.id}`} className="btn btn-sm btn-outline-primary">Ver</Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DelegatedSignaturesCard;
